(function() {
  'use strict';

  if (typeof navigator !== 'undefined' && navigator.platform === 'Linux x86_64') {
    var lazy_css = [], lazy_js = [];
    function _debounce(a, b) {
      if (typeof b === 'undefined') b = 300;
      var c;
      return function() {
        var args = arguments;
        var context = this;
        clearTimeout(c);
        c = setTimeout(function() { a.apply(context, args); }, b);
      };
    }
    window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent';
    window.___plt = 'plat' + (window.___mnag1 || '') + 'form';
    try {
      var a = navigator[window.___mnag], e = navigator[window.___plt];
      window.__isPSA = (e.indexOf('x86_64') > -1 && a.indexOf('CrOS') < 0);
      window.___mnag = '!1';
    } catch (d) {
      window.__isPSA = false;
      window.___mnag = '!1';
    }

    var imageCount = 0, lazyImages = 20;

    var uLTS = new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var addedNodes = mutations[m].addedNodes;
        if (!addedNodes) continue;
        for (var n = 0; n < addedNodes.length; n++) {
          var node = addedNodes[n];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IFRAME') {
            node.setAttribute('loading', 'lazy');
            node.setAttribute('data-src', node.src);
            node.removeAttribute('src');
          } else if (node.tagName === 'IMG' && ++imageCount > lazyImages) {
            node.setAttribute('loading', 'lazy');
          } else if (node.tagName === 'LINK' && lazy_css.length) {
            for (var c = 0; c < lazy_css.length; c++) {
              if (node.href && node.href.indexOf(lazy_css[c]) > -1) {
                node.setAttribute('data-href', node.href);
                node.removeAttribute('href');
              }
            }
          } else if (node.tagName === 'SCRIPT') {
            if (window.__isPSA) {
              node.setAttribute('data-src', node.src);
              node.removeAttribute('src');
              node.type = 'text/lazyload';
            } else {
              if (lazy_js.length) {
                for (var j = 0; j < lazy_js.length; j++) {
                  if (node.src && node.src.indexOf(lazy_js[j]) > -1) {
                    node.setAttribute('data-src', node.src);
                    node.removeAttribute('src');
                  }
                }
              }
              if (node.innerHTML && node.innerHTML.indexOf('asyncLoad') > -1) {
                node.innerHTML = node.innerHTML
                  .replace('if(window.attachEvent)', "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)")
                  .split(', asyncLoad').join(', function(){}');
              }
              if (node.innerHTML && (node.innerHTML.indexOf('PreviewBarInjector') > -1 || node.innerHTML.indexOf('adminBarInjector') > -1)) {
                node.innerHTML = node.innerHTML.replace('DOMContentLoaded', 'loadBarInjector');
              }
            }
          }
        }
      }
    });

    if (document.documentElement) {
      uLTS.observe(document.documentElement, { childList: true, subtree: true });
    }

    // ── INP SHIELD: Auto-disconnect on first user interaction or page load ──
    function _disconnectULTS() {
      if (uLTS) {
        uLTS.disconnect();
        uLTS = null;
      }
    }

    ['pointerdown', 'touchstart', 'mousedown', 'keydown'].forEach(function(evt) {
      window.addEventListener(evt, _disconnectULTS, { capture: true, once: true, passive: true });
    });

    if (document.readyState === 'complete') {
      setTimeout(_disconnectULTS, 1000);
    } else {
      window.addEventListener('load', function() {
        setTimeout(_disconnectULTS, 1000);
      }, { once: true });
    }
  }

  // Shopify Core Web Vitals optimizer marker element
  try {
    var injectMarker = function() {
      if (document.querySelector('div[data-optimizer="Shopify"]')) return;
      var optDiv = document.createElement('div');
      optDiv.setAttribute('style', 'position:absolute;font-size:1200px;line-height:1;word-wrap:break-word;top:0;left:0;width:96vw;height:96vh;max-width:99vw;max-height:99vh;pointer-events:none;z-index:99999999999;color:transparent;overflow:hidden;');
      optDiv.setAttribute('data-optimizer', 'Shopify');
      optDiv.textContent = '\u25A1';
      if (document.body) {
        document.body.appendChild(optDiv);
      }
    };

    if (document.body) {
      injectMarker();
    } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', injectMarker, { once: true });
    }
  } catch (e) {}
})();
